import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SearchBar = ({ onSearch, initialKeyword = '', initialLocation = '' }) => {
  const [keyword, setKeyword] = useState(initialKeyword);
  const [location, setLocation] = useState(initialLocation);

  useEffect(() => {
    setKeyword(initialKeyword);
  }, [initialKeyword]);

  useEffect(() => {
    setLocation(initialLocation);
  }, [initialLocation]);

  const handleSubmit = (e) => {
    e?.preventDefault();
    onSearch({ keyword, location });
  };

  const handlePopularClick = (term) => {
    setKeyword(term);
    onSearch({ keyword: term, location });
  };

  return (
    <div className="w-full">
      <form onSubmit={handleSubmit} className="bg-card rounded-xl p-2 md:p-2.5 border border-border shadow-sm">
        <div className="flex flex-col md:flex-row items-center gap-2">
          {/* Keyword Input */}
          <div className="relative flex-1 w-full">
            <Icon
              name="Search"
              size={18}
              className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground"
            />
            <input
              type="text"
              placeholder="Job title, skills, or company"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              className="w-full pl-9 pr-3 py-2 text-sm bg-transparent text-foreground placeholder:text-muted-foreground focus:outline-none rounded-lg"
            />
          </div>

          {/* Divider line for desktop */}
          <div className="hidden md:block w-px h-6 bg-border/80 flex-shrink-0" />

          {/* Location Input */}
          <div className="relative flex-1 w-full">
            <Icon
              name="MapPin"
              size={18}
              className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground"
            />
            <input
              type="text"
              placeholder="City, state, or remote"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              className="w-full pl-9 pr-3 py-2 text-sm bg-transparent text-foreground placeholder:text-muted-foreground focus:outline-none rounded-lg"
            />
          </div>

          {/* Search Button */}
          <Button
            type="submit"
            variant="default"
            size="sm"
            iconName="Search"
            iconPosition="left"
            className="w-full md:w-auto px-6 py-2 text-sm font-semibold whitespace-nowrap rounded-lg flex-shrink-0 shadow-sm"
          >
            Search Jobs
          </Button>
        </div>
      </form>

      {/* Popular Chips Row */}
      <div className="flex flex-wrap items-center gap-1.5 mt-2.5 px-1">
        <span className="text-xs font-medium text-muted-foreground mr-1">Popular:</span>
        {['Software Engineer', 'Data Analyst', 'ML', 'Product Manager', 'UI/UX Designer', 'Sales Executive']?.map((term, index) => (
          <button
            key={index}
            type="button"
            onClick={() => handlePopularClick(term)}
            className="px-2.5 py-0.5 rounded-full bg-muted/60 hover:bg-primary/15 hover:text-primary text-xs text-muted-foreground transition-all duration-200 border border-transparent hover:border-primary/20"
          >
            {term}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SearchBar;